import { render, staticRenderFns } from "./Rdp.vue?vue&type=template&id=905f23cc&scoped=true&"
import script from "./Rdp.vue?vue&type=script&lang=js&"
export * from "./Rdp.vue?vue&type=script&lang=js&"
import style0 from "./Rdp.vue?vue&type=style&index=0&id=905f23cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905f23cc",
  null
  
)

export default component.exports